import React from "react";
import me from "../../assets/img/profile_headshot.webp";
import pd from "../../assets/resume/Kunal M Karnik.pdf";
import { Link } from "react-router-dom";

const About = (props) => {
  return (
    <section id="about" className="about">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>About</h2>
          <p>Find out who I am, where I am from and what I am all about.</p>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <img src={me} className="img-fluid" alt="" />
          </div>
          <div className="col-lg-8 pt-4 pt-lg-0 content">
            <h3>Fullstack Mobile App &amp; Web Developer.</h3>
            <div className="row" style={{ marginTop: "20px" }}>
              <div className="col-lg-6">
                <ul>
                  <li>
                    <i className="icofont-rounded-right" />{" "}
                    <strong>Birthday:</strong> 21st May, 1993
                  </li>
                  <li>
                    <i className="icofont-rounded-right" />{" "}
                    <strong>Pronouns:</strong> He/His
                  </li>
                  <li>
                    <i className="icofont-rounded-right" />{" "}
                    <strong>Website:</strong> kunalkarnik.com
                  </li>
                  <li>
                    <i className="icofont-rounded-right" />{" "}
                    <strong>Experience:</strong> 8+ years
                  </li>
                  <li>
                    <i className="icofont-rounded-right" />{" "}
                    <strong>City:</strong> Pune, India
                  </li>
                </ul>
              </div>
              <div className="col-lg-6">
                <ul>
                  <li>
                    <i className="icofont-rounded-right" />{" "}
                    <strong>Age:</strong> 32
                  </li>
                  <li>
                    <i className="icofont-rounded-right" />{" "}
                    <strong>Nationality:</strong> Indian
                  </li>
                  <li>
                    <i className="icofont-rounded-right" />{" "}
                    <strong>Degree:</strong> Masters
                  </li>
                  <li>
                    <i className="icofont-rounded-right" />{" "}
                    <strong>Email:</strong> hello@kunalkarnik.com
                  </li>
                  <li>
                    <i className="icofont-rounded-right" />{" "}
                    <strong>Freelance:</strong> Available
                  </li>
                </ul>
              </div>
            </div>
            <a
              target="_blank"
              rel="noreferrer"
              href={pd}
              className="button uppercase"
            >
              Download Resume
            </a>
            <Link className="button uppercase" to="/about">
              Read More About Me
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
